import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";

const AperturarCajaModal = ({ show, onClose, onSave, showCreate, title, initDataApertura }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset: resetModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [cajasActivas, setCajasActivas] = useState(CONFIGURACIONES.INIT.ARRAY);

    useEffect(() => {
        resetModal();
        if (initDataApertura !== CONFIGURACIONES.INIT.NULL) {
            setCajasActivas(initDataApertura.cajas);
        }
    }, [initDataApertura]);


    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onSave)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="cajaId" className="control-label col-form-label">Caja <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("cajaId", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })} className="form-control" id="cajaId"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            cajasActivas.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.cajaId && errorsModal.cajaId.message }</small>
                                </div>
                            </div>

                             <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="montoAperturaSoles" className="control-label col-form-label">Importe <small className="text-muted">(Soles)</small> <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="montoAperturaSoles"
                                        id="montoAperturaSoles"
                                        {...registerModal("montoAperturaSoles", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_DECIMAL_INCLUDE_ZERO,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.montoAperturaSoles && errorsModal.montoAperturaSoles.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="montoAperturaDolares" className="control-label col-form-label">Importe <small className="text-muted">(Dólares)</small> <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="montoAperturaDolares"
                                        id="montoAperturaDolares"
                                        {...registerModal("montoAperturaDolares", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_DECIMAL_INCLUDE_ZERO,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.montoAperturaDolares && errorsModal.montoAperturaDolares.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => onClose(CONFIGURACIONES.INIT.FLAG_CLOSE)}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default AperturarCajaModal;
